import React, { FC } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import Link from "next/link";
import useI18n from "evcharging/hooks/useI18n";

interface PaginationProps {
  page: number;
  size: number;
  total: number;
}

const PaginationNextPrev: FC<PaginationProps> = (props) => {
  const { page, size, total } = props;
  const { t } = useI18n();
  const theme = useTheme();
  const styles = createStyles(theme);
  const totalPages = Math.ceil(total / size);
  const { pathname, query } = useRouter();
  const prev = page - 1;
  const next = page + 1;

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className={styles.root}>
      {prev > 0 ? (
        <Link href={{ pathname, query: { ...query, page: prev } }} prefetch={false}>
          <a className={clsx(styles.button, styles.arrow, styles.active)} rel={'prev'}>
            {t('action.prev')}
          </a>
        </Link>
      ) : (
        <button className={clsx(styles.button, styles.arrow)} disabled>
          {t('action.prev')}
        </button>
      )}
      {next < totalPages + 1 ? (
        <Link href={{ pathname, query: { ...query, page: next } }} prefetch={false}>
          <a className={clsx(styles.button, styles.arrow, styles.active)} rel={'next'}>
            {t('action.next')}
          </a>
        </Link>
      ) : (
        <button className={clsx(styles.button, styles.arrow)} disabled>
          {t('action.next')}
        </button>
      )}
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    display: flex;
    justify-content: center;
  `,
  button: css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    padding: 0 10px;
    height: 50px;
    background-color: #fff;
    border: 1px solid ${theme.colors.accent};
    border-radius: 10px;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: ${theme.colors.accent};
    margin-right: 15px;
  `,
  arrow: css`
    background-color: #f6f8f9;
    border: 1px solid #f6f8f9;
    svg {
      path {
        fill: #6e7c87;
      }
    }
  `,
  active: css`
    color: #fff;
    background-color: ${theme.colors.accent};
    svg {
      path {
        fill: #fff;
      }
    }
  `,
});

export default PaginationNextPrev;
